import { useEffect, useState } from "react";
import { ChequeActivityData, ChequeActivityDeliver } from "../types";
import { BackContainer, Cheque } from "../../../../types";
import { ChequeApi } from "../../../../api";
import { ChequeDetails } from "../../../cheque";
import { useAlertStore } from "../../../../stores";

const ChequeDeliverActivityPopup = <T extends {}>(
  props: BackContainer<ChequeActivityData, T>
) => {
  const activity = props.data as ChequeActivityDeliver;

  const pushAlert = useAlertStore((s) => s.pushAlert);

  const [cheque, setCheque] = useState<Cheque | null>(null);

  useEffect(() => {
    ChequeApi.getById(activity.id.$oid)
      .then((c) => {
        setCheque(c);
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return cheque ? <ChequeDetails {...cheque} back={props.back} /> : <></>;
};

export default ChequeDeliverActivityPopup;
